import React, { useRef, useState } from 'react'
import styled, { css } from 'styled-components'

const videoMp4 = 'https://www.w3schools.com/html/mov_bbb.mp4'
const videoOgg = 'https://www.w3schools.com/html/mov_bbb.ogg'

const VideoWrapper = styled.div`
  position: relative;
  height: 100%;
  background: #181a1a;
`

const PlayButton = styled.button<{ isPlaying: boolean }>`
  ${({ theme, isPlaying }) => css`
    position: absolute;
    z-index: 1;

    ${!isPlaying &&
    css`
      left: 50%;
      top: 50%;
      width: 48px;
      height: 48px;
      transform: translate(-50%, -50%);
      background: ${theme.colors.black};
      fill: ${theme.colors.white};
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
    `}

    ${isPlaying &&
    css`
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      opacity: 0;
    `}
  `}
`

const VideoPlayer = () => {
  const videoRef = useRef<any>(null)
  const [isPlaying, setIsPlaying] = useState(false)

  const playHandler = () => {
    if (isPlaying) {
      videoRef.current.pause()
    } else {
      videoRef.current.play()
    }
    setIsPlaying(!isPlaying)
  }

  return (
    <VideoWrapper>
      <PlayButton onClick={playHandler} isPlaying={isPlaying}>
        <svg width="21px" height="21px">
          <use xlinkHref="#play" />
        </svg>
      </PlayButton>
      <video controls={false} style={{ width: '100%', height: '100%' }} ref={videoRef}>
        <source src={videoMp4} type="video/mp4" />
        <source src={videoOgg} type="video/ogg" />
      </video>
    </VideoWrapper>
  )
}

export default VideoPlayer
